import makeStyles from '@material-ui/core/styles/makeStyles'

const useNewClientStyle = makeStyles((theme) => ({
  paper: {
    padding: '3rem',
  },
}))

export { useNewClientStyle }
